/* eslint-disable react/no-multi-comp */

import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';
import ImageIcon from '@mui/icons-material/Image';
import FileIcon from '@mui/icons-material/InsertDriveFile';
import React, {FC} from 'react';

export const ExcelIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='Excel File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zm-2.34 7.39l-3.45-5.1h2.73l2.1 3.42 2.175-3.42h2.58L9.36 14.405 13.095 20H10.29l-2.34-3.705L5.565 20h-2.64l3.735-5.61z'
            fillRule='nonzero'
        />
    </SvgIcon>
);

export const OneNoteIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='OneNote File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zM3.535 9.29h2.34l4.47 7.185h.03V9.29h2.205V20h-2.355L5.77 12.83h-.03V20H3.535V9.29z'
            fillRule='nonzero'
        />
    </SvgIcon>
);

export const PDFIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='PDF File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M9 7h5.5L9 1.5V7zM2 0h8l6 6v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm4.93 10.44c.41.9.93 1.64 1.53 2.15l.41.32c-.87.16-2.07.44-3.34.93l-.11.04.5-1.04c.45-.87.78-1.66 1.01-2.4zm6.48 3.81c.18-.18.27-.41.28-.66.03-.2-.02-.39-.12-.55-.29-.47-1.04-.69-2.28-.69l-1.29.07-.87-.58c-.63-.52-1.2-1.43-1.6-2.56l.04-.14c.33-1.33.64-2.94-.02-3.6a.853.853 0 0 0-.61-.24H6.7c-.37 0-.7.39-.79.77-.37 1.33-.15 2.06.22 3.27v.01c-.25.88-.57 1.9-1.08 2.93l-.96 1.8-.89.49c-1.2.75-1.77 1.59-1.88 2.12-.04.19-.02.36.05.54l.03.05.48.31.44.11c.81 0 1.73-.95 2.97-3.07l.18-.07c1.03-.33 2.31-.56 4.03-.75 1.03.51 2.24.74 3 .74.44 0 .74-.11.91-.3zm-.41-.71l.09.11c-.01.1-.04.11-.09.13h-.04l-.19.02c-.46 0-1.17-.19-1.9-.51.09-.1.13-.1.23-.1 1.4 0 1.8.25 1.9.35zM3.83 15c-.65 1.19-1.24 1.85-1.69 2 .05-.38.5-1.04 1.21-1.69l.48-.31zm3.02-6.91c-.23-.9-.24-1.63-.07-2.05l.07-.12.15.05c.17.24.19.56.09 1.1l-.03.16-.16.82-.05.04z'
            fillRule='nonzero'
        />
    </SvgIcon>
);

export const PowerPointIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='PowerPoint File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zM4.035 9.29h4.83c.67 0 1.24.097 1.71.293a3.2 3.2 0 0 1 1.148.772c.295.32.51.685.644 1.095a4.073 4.073 0 0 1 0 2.543c-.135.415-.35.782-.645 1.102a3.2 3.2 0 0 1-1.147.772c-.47.196-1.04.293-1.71.293H6.39V20H4.035V9.29zm2.355 5.04h1.83c.27 0 .53-.02.78-.06.25-.04.47-.117.66-.232.19-.116.342-.278.457-.488.116-.21.173-.485.173-.825 0-.34-.057-.615-.172-.825a1.267 1.267 0 0 0-.458-.488A1.815 1.815 0 0 0 9 11.18c-.25-.04-.51-.06-.78-.06H6.39v3.21z'
            fillRule='nonzero'
        />
    </SvgIcon>
);

export const WordIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='Word File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zm3.235 13h-2.34L8.08 12.71h-.03L6.265 20H3.88L1.045 9.29H3.4l1.695 7.29h.03l1.86-7.29H9.19l1.83 7.38h.03l1.755-7.38h2.31L12.235 20z'
            fillRule='nonzero'
        />
    </SvgIcon>
);

type IconInfo = {icon: React.ComponentType<SvgIconProps>; color: string};

export const getFileIcon = (filename?: string): IconInfo => {
    const fileType = filename ? filename.split('.').pop() : '';

    switch (fileType) {
        case 'one':
            return {
                icon: OneNoteIcon,
                color: '#7C3876'
            };

        case 'pdf':
            return {
                icon: PDFIcon,
                color: '#F00000'
            };

        case 'ppt':
        case 'pptx':
            return {
                icon: PowerPointIcon,
                color: '#D24625'
            };

        case 'doc':
        case 'odt':
        case 'txt':
        case 'html':
        case 'docx':
            return {
                icon: WordIcon,
                color: '#2A5699'
            };

        case 'apng':
        case 'avif ':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
        case 'webp':
            return {
                icon: ImageIcon,
                color: '#666666'
            };

        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'xlsb':
        case 'csv':
        case 'json':
            return {
                icon: ExcelIcon,
                color: '#11764B'
            };

        default:
            return {
                icon: FileIcon,
                color: '#666666'
            };
    }
};
